import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-acepta-solicitud',
  templateUrl: './acepta-solicitud.component.html',
  styleUrls: ['./acepta-solicitud.component.css']
})
export class AceptaSolicitudComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<AceptaSolicitudComponent>,
    private _userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

  cerrar(data){
    this.dialogRef.close({ data: data })
  }
}
